<template>
  <div class="wl-create">
    <b-overlay :show="loading">
      <div class="wl-header-bar">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="d-inline">{{ settings.list_title }}</h1>
              Settings
            </div>
          </div>
        </div>
      </div>

      <div class="wl-body">
        <div class="container">
          <wine-list-settings
            v-model="settings"
            @valid="onValid"
          ></wine-list-settings>
          <div class="row">
            <div class="col-12">
              <b-button variant="primary" :disabled="!valid" @click="save"
                >Save Changes</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import WineListSettings from "@/components/winelist/WineListSettings";
import { mapState } from "vuex";

export default {
  components: {
    WineListSettings,
  },
  data() {
    return {
      id: "",
      settings: false,
      valid: false,
      loading: true,
    };
  },
  watch: {
    active_list(val) {
      this.settings = JSON.parse(JSON.stringify(val));
      this.loading = false;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.$store.dispatch("winelist/load_and_activate_full_list", this.id);
  },
  computed: {
    ...mapState("winelist", ["active_list"]),
  },
  methods: {
    save() {
      if (this.valid) {
        this.loading = true;
        this.$store
          .dispatch("winelist/save_active_list", this.settings)
          .then(() => {
            this.$router.push("/edit/" + this.id);
          })
          .catch((err) => {
            this.showError("Could not create list", err.response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$bvModal.msgBoxOk(
          "Please ensure all fields are filled out correctly."
        );
      }
    },
    onValid(state) {
      this.valid = state;
    },
  },
};
</script>
